import saveAs from 'file-saver'
import writeExcelFile from 'write-excel-file/browser'

export const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

export type ExcelCellValue = string | number | boolean | Date | null
export type ExcelSheetData = ExcelCellValue[][]

const toExcelCellValue = (value: unknown): ExcelCellValue => {
  if (value === undefined || value === null) {
    return null
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value instanceof Date) {
    return value
  }

  return String(value)
}

export const createExcelSheetData = (keys: string[], rows: Record<string, unknown>[]): ExcelSheetData => {
  if (rows.length === 0) {
    return []
  }

  return [keys, ...rows.map((row) => keys.map((key) => toExcelCellValue(row[key])))]
}

export const calculateExcelColumnWidths = (
  keys: string[],
  rows: Record<string, unknown>[],
  maxWidth?: number
): number[] => {
  return keys.map((key) => {
    let maxLength = key.length
    rows.forEach((row) => {
      const cellValue = row[key] ? String(row[key]) : ''
      if (cellValue.length > maxLength) {
        maxLength = cellValue.length
      }
    })

    const width = maxLength + 2
    return maxWidth === undefined ? width : Math.min(width, maxWidth)
  })
}

export const createExcelBlob = async (sheetData: ExcelSheetData, columnWidths: number[]): Promise<Blob> => {
  const blob = await writeExcelFile(sheetData, {
    columns: columnWidths.map((width) => ({ width })),
    sheet: 'Sheet1',
  }).toBlob()

  return new Blob([blob], { type: EXCEL_MIME_TYPE })
}

export const downloadExcelFile = async (
  sheetData: ExcelSheetData,
  columnWidths: number[],
  fileName: string
): Promise<void> => {
  const dataBlob = await createExcelBlob(sheetData, columnWidths)
  saveAs(dataBlob, fileName || 'export')
}
